<template>
  <component :is="current" v-bind="$attrs" />
</template>

<script setup>
import { useUiWrapper } from "@/utils/uiWrapper";
import HeaderViewOld from "./Old/HeaderViewOld.vue";
import NewHeaderView from "./New/NewHeaderView.vue";

const current = useUiWrapper(HeaderViewOld, NewHeaderView);
</script>
